import { PropsWithChildren, Suspense } from "react";

type AsyncProps = PropsWithChildren;

export default function Await(props: AsyncProps) {
  return <Suspense>{props.children}</Suspense>;
}
